import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { ModalDefinition, OverlayService } from 'app/services/overlay.service';
import { catchError } from 'rxjs';

@Component({
	selector: 'login-forgot-password',
	templateUrl: './login-forgot-password.component.html',
	styleUrls: ['./login-forgot-password.component.scss'],
})
export class LoginForgotPasswordComponent implements OnInit {
	@ViewChild('emailSentModal') emailSentModal: TemplateRef<any>;

	public passwordErrorOccured: boolean;
	public forgotPasswordErrorMessage: string;
	public forgotPasswordSent: boolean;
	public emailAddress: string;
	public busy: boolean;

	constructor(
		private authenticationService: AuthenticationService,
		private router: Router,
		private translate: TranslateService,
		private overlayService: OverlayService
	) {	}

	ngOnInit() { }

	requestNewPassword() {
		this.passwordErrorOccured = false;
		this.forgotPasswordErrorMessage = '';
		if (this.emailAddress && this.emailAddress !== '') {
			this.busy = true;
			this.authenticationService.requestNewPassword(this.emailAddress)
				.pipe(
					catchError((error: any) => {
						this.busy = false;
						this.passwordErrorOccured = true;
						this.forgotPasswordErrorMessage = error.error.body;
						throw error;
					})
				)
				.subscribe((response: any) => {
					this.busy = false;

					this.showEmailSentModal();
					this.forgotPasswordErrorMessage = '';
				});
		} else {
			this.passwordErrorOccured = true;
			this.forgotPasswordErrorMessage = this.translate.instant('HELP.PROVIDE_EMAIL_ADDRESS');
		}
	}

	cancel(): void {
		this.router.navigate(['login']);
	}

	private showEmailSentModal(): void {
		const modal: ModalDefinition = {
			icon: 'lock',
			title: this.translate.instant('EMAIL_SENT'),
			component: {
				name: 'custom-content',
				templateRef: this.emailSentModal,
				theme: 'rb'
			}
		};
		this.overlayService.createModal(modal);
	}
}
